export default __webpack_public_path__ + "static/media/mode-quick-game-image.389a3d1c.svg";